import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { MdClear as ExitIcon, MdKeyboardArrowLeft as ArrowLeftIcon } from 'react-icons/md';

import {
  ADDITIONAL_RESOURCES_SECTION_NAME,
  PAGE_HELP_SECTION_NAME,
  RELEASE_NOTES_SECTION_NAME,
  SEARCH_DOCUMENTATION_SECTION_NAME,
} from './helpMenu.constants';

import { HelpContentPropTypes } from '../shared/proptypes';
import ContentButtonList from './contentButtonList.component';
import ContentButton from './contentButton.component';
import getPathnameForHelpContent from './utils/getPathnameForHelpContent';

const SectionPage = ({
  history,
  sectionName,
  helpContents,
  onClose,
  deleteContent,
  deleteContentLoading,
  addContent,
  addContentLoading,
  contentEditable,
}) => {
  const subsectionContents = sectionName === PAGE_HELP_SECTION_NAME
    ? helpContents.filter(contentItem => contentItem.section === null)
    : helpContents.filter(contentItem => contentItem.section === sectionName);

  const handleAddContent = useCallback(
    ({ title, settings }) => (
      sectionName === PAGE_HELP_SECTION_NAME
        ? addContent({ pageUrl: getPathnameForHelpContent(), title, settings })
        : addContent({ title, sectionName, settings })
    ),
    [addContent, sectionName]
  );

  const handleDeleteContent = useCallback(
    contentId => event => {
      event.stopPropagation();
      deleteContent(contentId);
    },
    [deleteContent]
  );

  return (
    <>
      <h4 className="popup-header">
        <div className="header">
          <div className="popup-header-back-arrow" onClick={history.goBack}>
            <ArrowLeftIcon />
          </div>
          <h5>{sectionName}</h5>
          <ExitIcon onClick={onClose} className="popup-header-exit" />
        </div>
      </h4>
      <div className="popup-body">
        <ContentButtonList
          sectionName={sectionName}
          helpContents={subsectionContents}
          addContent={contentEditable ? handleAddContent : null}
          addContentLoading={addContentLoading}
          deleteContent={contentEditable ? handleDeleteContent : null}
          deleteContentLoading={deleteContentLoading}
          additionalContent={
            sectionName === ADDITIONAL_RESOURCES_SECTION_NAME
              ? (
                <>
                  <ContentButton to={`/search`}>
                    {SEARCH_DOCUMENTATION_SECTION_NAME}
                  </ContentButton>
                  <ContentButton to={`/releaseNotes`}>
                    {RELEASE_NOTES_SECTION_NAME}
                  </ContentButton>
                </>
              )
              : null
          }
        />
      </div>
    </>
  );
};

SectionPage.propTypes = {
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  sectionName: PropTypes.string.isRequired,
  helpContents: PropTypes.arrayOf(HelpContentPropTypes).isRequired,
  onClose: PropTypes.func.isRequired,
  deleteContent: PropTypes.func.isRequired,
  deleteContentLoading: PropTypes.bool.isRequired,
  addContent: PropTypes.func.isRequired,
  addContentLoading: PropTypes.bool.isRequired,
  contentEditable: PropTypes.bool.isRequired,
};

export default SectionPage;
